<template>
  <div class="th-card th-card-hover th-hover-pointer container-card-course-progress">
      <div class="image">
          <!-- <img src="/img/thumbnail/2.png" alt=""> -->
          <img :src="content.thumbnailSmall ? backendUrl + content.thumbnailSmall : content.thumbnail ? backendUrl + content.thumbnail : '/img/thumbnail/empty.png'" :alt="content.title">
      </div>
      <div class="content">
        <div class="title">{{content && content.title ? content.title : 'Kajian Kitab Bulughul Maram'}}</div>
        <div class="meta">Terakhir belajar {{lastUpdate}}</div>
        <div class="price-tag">
            <va-lozenge :uppercase="false" type="success">Kajian</va-lozenge>
        </div>
        <div class="course-progress">
            <progress-bar
                size="large"
                :bar-border-radius="100"
                bg-color="#F2F2F2"
                bar-color="#3e4095"
                :val="lessonProgress.finishedPercentile * 100"
            />
            <div class="progress-detail">
                <p><span>{{lessonProgress.finishedCount}}</span> dari <span>{{this.content.totalLessons}}</span> materi telah selesai</p>
                <p class="text-progress">{{lessonProgress.finishedPercentile * 100}}%</p>
            </div>
        </div>
      </div>
  </div>
</template>
<script>
import ProgressBar from 'vue-simple-progress'
import moment from 'moment'
export default {
  components: {
    ProgressBar,
  },
  props: {
    content: {
      type: Object,
    },
  },
  data() {
    return {
      backendUrl: process.env.VUE_APP_BACKEND_URL,
    }
  },
  computed: {
    lessonProgress() {
      let res = {
        finishedCount: 0,
        finishedPercentile: 0,
        onProgressCount: 0,
        onProgressPercentile: 0,
      }

      if (this.content) {
        this.content.lessonLogs.forEach(log => {
          if (log.status === 'finished') res.finishedCount++
          if (log.status === 'on progress') res.onProgressCount++
        })

        if (res.finishedCount === 0 && this.content.totalLessons === 0) res.finishedPercentile = 1
        else res.finishedPercentile = (res.finishedCount / Number(this.content.totalLessons)).toFixed(1)

        if (res.onProgressCount === 0 && this.content.totalLessons === 0) res.onProgressPercentile = 1
        else res.onProgressPercentile = (res.onProgressCount / Number(this.content.totalLessons)).toFixed(1)
      } else {
        res = {
          finishedCount: 4,
          finishedPercentile: 0.5,
          onProgressCount: 0,
          onProgressPercentile: 0,
        }
      }

      return res
    },
    lastUpdate() {
      if (this.content) {
        const diff = moment().diff(this.content.lastUpdate, 'minutes')
        console.log(diff, this.content)
        if (diff < 60) {
          return diff + ' menit yang lalu'
        } else if (diff > 60 && diff < 70) {
          return '1 jam yang lalu'
        } else if (diff > 70) {
          const momentLastUpdate = moment(this.content.lastUpdate).locale('id')
          const date = momentLastUpdate.format('DD MMM YYYY')
          const time = momentLastUpdate.format('HH:mm')
          return 'pada ' + date + ' pukul ' + time
        }
      }

      return '5 menit yang lalu'
    },
  },
}
</script>

<style lang="scss">
.container-card-course-progress {
    // width: 360px;
    width: 100%;
    // height: 300px;
    // max-width: 360px;
    // max-height: 350px;
    overflow: hidden;

    .wishlist {
        opacity: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        top: 0;
        right: 14px;
        width: 40px;
        height: 40px;
        background: #FFFFFF;
        border-radius: 0 0 4px 4px;
        z-index: 1;
        cursor: pointer;
        transition: opacity .2s ease-in-out;

        &.active {
            background: #3e4095;
        }
    }

    .image {

        position: relative;
        border-radius: 4px 4px 0 0;
        height: 160px;

        &:before {
            content: "";
            display: block;
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            background: linear-gradient(0deg, rgba(0, 0, 0, 0.51) 0%, rgba(255, 255, 255, 0) 100%);
        }

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .content {
        display: flex;
        flex-direction: column;
        padding: 12px 14px 14px 14px;

        .title {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 16px;
            font-weight: 600;
        }

        .meta {
          font-weight: 400;
          font-size: 12px;
          margin-top: 2px;
          margin-bottom: 10px;
        }

        .price-tag {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin: 10px 0 10px 0;
        }

        .course-progress {
            .progress-detail {
                margin-top: 4px;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                p span {
                    font-weight: bold;
                }

                .text-progress {
                    color: #3e4095;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
